module.exports = __webpack_public_path__ + "static/media/autoleaves.c51d78aa.svg";